var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScatter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5836 16.751H2.58356V4.25098",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.47607,
    cy: 10.1734,
    r: 1.06891,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.7292,
    cy: 11.2994,
    r: 1.06891,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.4481,
    cy: 8.43414,
    r: 1.06891,
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatter);
export default __webpack_public_path__ + "static/media/Scatter.46a2ac903f1c617bfd6b30764e1a1ae1.svg";
export { ForwardRef as ReactComponent };